import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "mb-10 fv-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3" }, "Nama Desain", -1)
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Pilih Posisi Depan / Belakang", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "DEPAN" }, "DEPAN", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "BELAKANG" }, "BELAKANG", -1)
const _hoisted_9 = { class: "fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-5" }, "Pilih Posisi Kartu", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_personal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/media/card/potrait.jpg" })
  ])
], -1)
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "kt_create_account_form_account_type_corporate"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/media/card/landscape.jpg" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Field, {
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        name: "namaDesign",
        placeholder: "",
        value: ""
      }),
      _createVNode(_component_ErrorMessage, {
        name: "nameDesign",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_Field, {
        name: "posisi",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "posisi",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Field, {
            type: "radio",
            class: "btn-check",
            name: "posisiKartu",
            value: "POTRAIT",
            id: "kt_create_account_form_account_type_personal"
          }),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Field, {
            type: "radio",
            class: "btn-check",
            name: "posisiKartu",
            value: "LANDSCAPE",
            id: "kt_create_account_form_account_type_corporate"
          }),
          _hoisted_15
        ]),
        _createVNode(_component_ErrorMessage, { name: "posisiKartu" })
      ])
    ])
  ]))
}